export default __webpack_public_path__ + "static/media/custom2b.2280f3fb.png";